import { Box } from 'src/components/UI/Box';

interface StepHeaderProps {
  title: string;
  subtitle: string;
}

export function StepHeader({ title, subtitle }: StepHeaderProps) {
  return (
    <Box flexShrink={0}>
      <Box mb="12px">
        <Box as="h1" fontFamily={'Ambit'} fontSize={30} color="#16002C" fontWeight="600">
          {title}
        </Box>
      </Box>

      <Box mb="40px">
        <Box fontFamily={'Ambit'} fontSize={16} fontWeight={100} color="gray.800">
          {subtitle}
        </Box>
      </Box>
    </Box>
  );
}
